import jwtDecode from 'jwt-decode'

export const getClientIdFromToken = (accessToken: string): string | undefined => {
  if (!accessToken) return

  const decoded = jwtDecode(accessToken) as any

  return decoded['https://christies-account.com/client-guid'] as string
}
